import { Route, Routes } from "react-router-dom"
import Main from "../pages/main"
import { TimeConfigProvider } from "../context"
import { Form } from "../pages/form"
import { FormEdit } from "../pages/edit"

const TimeConfigRoutes = () => {
  return (
    <TimeConfigProvider>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/form" element={<Form />} />
        <Route path="/form/:id" element={<FormEdit />} />
      </Routes>
    </TimeConfigProvider>
  )
}

export default TimeConfigRoutes
